// extracted by mini-css-extract-plugin
module.exports = {"products":"UN","productContainer":"VN","overFlowVisible":"WN","resultsHeading":"XN","oosMessaging":"YN"};